<mat-card>
  <div *ngIf="loading">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  </div>
  <mat-card-content>
    <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
      <div class="faux-label">IFC Upload Feed |
        <span *ngIf="isNotErrorFeed" class="text-warning ifc-link" (click)="toggleErrorIfcFeed()">Show Errors</span>
        <span *ngIf="!isNotErrorFeed" class="text-success ifc-link" (click)="toggleErrorIfcFeed()">Show Successful</span>
      </div>
      <button mat-flat-button color="accent" (click)="viewFullReport()">
        <mat-icon>assessment</mat-icon> View Entire Feed
      </button>
    </div>
    <ng-container *ngIf="isNotErrorFeed">
      <ng-container *ngFor="let item of homeIfcFiles">
        <mat-card class="contrast card-link" [class.banner-success]="isRecent(item?.dateAdded)" [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="navigateToIfc(item?.home, item?.name, item?.version, false)">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="25" fxLayoutAlign="start center" fxLayout="row">
              <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}">{{ capitalizeFirstLetter(item?.home) }}</strong>
            </div>
            <div fxFlex="75" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="18px">
              <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                <p fxHide.md><small>name</small></p>
                <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">{{ item?.name }} <span class="text-info">v{{ item?.version}}</span></div>
                <div fxHide.lt-sm class="m-l-5 m-r-5">|</div>
                <p fxHide.md><small>uploaded</small></p>
                <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">{{ item?.dateAdded | date:'short' }}</div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!isNotErrorFeed">
      <ng-container *ngFor="let item of homeIfcFileErrors">
        <mat-card [matTooltip]="item?.error" class="contrast card-link" [class.banner-error]="isRecent(item?.dateAdded)" [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="navigateToIfc(item?.home, item?.ifcFile, item?.version, true)">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="25" fxLayoutAlign="start center" fxLayout="row">
              <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}">{{ capitalizeFirstLetter(item?.home) }}</strong>
            </div>
            <div fxFlex="75" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="18px">
              <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                <p><small>name</small></p>
                <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">{{ item?.ifcFile }} <span class="text-info">v{{ item?.version}}</span></div>
                <div fxHide.lt-sm class="m-l-5 m-r-5">|</div>
                <p><small>uploaded</small></p>
                <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">{{ item?.dateAdded | date:'short' }}</div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </ng-container>
  </mat-card-content>
</mat-card>